<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-delivery-legal-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <BaseInfo ref="biRef" :pdfTransforming="pdfTransforming" />
            <div class="title-container">
                <span class="title">资质信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型"></el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、运营能力（本项由运营平台负责修订）</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="130"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明" min-width="550">
                    <template slot-scope="scope">
                        <el-table v-if="scope.$index === 0" :data="scope.row.customerList" header-row-class-name="header-bg">
                            <el-table-column prop="customerName" label="客户名称">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>客户名称</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.customerName }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.customerName, 'customerName', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.customerName" placeholder="客户名称"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="scale" label="运作规模">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>运作规模</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.scale }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.scale, 'scale', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.scale" placeholder="万元"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="serviceType" label="服务行业">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>服务行业</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.serviceType }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.serviceType, 'serviceType', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.serviceType" placeholder="服务行业"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operationTime" label="运作年限">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>运作年限</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.operationTime }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.operationTime, 'operationTime', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.operationTime"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="deliveryScenario" label="配送场景">
                                <template slot="header" slot-scope="cuScope">
                                    <span class="required">*</span><span>配送场景</span>
                                </template>
                                <template slot-scope="cuScope">
                                    <span v-if="pdfTransforming">{{ cuScope.row.deliveryScenario }}</span>
                                    <el-input v-else :class="cuInputError(cuScope.row.deliveryScenario, 'deliveryScenario', cuScope.row, cuScope.$index) ? 'is-error' : ''" v-model.trim="cuScope.row.deliveryScenario"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-if="scope.$index === 1">
                            <div>可调配车辆：</div>
                            <div>车辆满足率=满足车辆数/需求车辆数*100%</div>
                            <el-table :data="scope.row.vehicleList" header-row-class-name="header-bg">
                                <el-table-column prop="cargoMax" label="承接线路高峰货量（吨/方）">
                                    <template slot="header" slot-scope="scope">
                                        <span class="required">*</span><span>承接线路高峰货量（吨/方）</span>
                                    </template>
                                    <template slot-scope="veScope">
                                        <span v-if="pdfTransforming">{{ veScope.row.cargoMax }}</span>
                                        <el-input v-else :class="veInputError(veScope.row.cargoMax, 'cargoMax', veScope.row, veScope.$index) ? 'is-error' : ''" v-model.trim="veScope.row.cargoMax"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="carNumberMax" label="高峰需求车辆数">
                                    <template slot="header" slot-scope="scope">
                                        <span class="required">*</span><span>高峰需求车辆数</span>
                                    </template>
                                    <template slot-scope="veScope">
                                        <span v-if="pdfTransforming">{{ veScope.row.carNumberMax }}</span>
                                        <el-input v-else :class="veInputError(veScope.row.carNumberMax, 'carNumberMax', veScope.row, veScope.$index) ? 'is-error' : ''" v-model.trim="veScope.row.carNumberMax"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="availableSelfCar" label="可调配自有车">
                                    <template slot="header" slot-scope="scope">
                                        <span class="required">*</span><span>可调配自有车</span>
                                    </template>
                                    <template slot-scope="veScope">
                                        <span v-if="pdfTransforming">{{ veScope.row.availableSelfCar }}</span>
                                        <el-input v-else :class="veInputError(veScope.row.availableSelfCar, 'availableSelfCar', veScope.row, veScope.$index) ? 'is-error' : ''" v-model.trim="veScope.row.availableSelfCar"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="availableCooperationCar" label="可调配合作车">
                                    <template slot="header" slot-scope="scope">
                                        <span class="required">*</span><span>可调配合作车</span>
                                    </template>
                                    <template slot-scope="veScope">
                                        <span v-if="pdfTransforming">{{ veScope.row.availableCooperationCar }}</span>
                                        <el-input v-else :class="veInputError(veScope.row.availableCooperationCar, 'availableCooperationCar', veScope.row, veScope.$index) ? 'is-error' : ''" v-model.trim="veScope.row.availableCooperationCar"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalCar" label="合计车辆数"></el-table-column>
                                <el-table-column prop="carRite" label="车辆满足率"></el-table-column>
                            </el-table>
                        </div>
                        <div v-else v-html="scope.row.wdsm"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="pfbz" label="评分标准" min-width="300">
                    <template slot-scope="scope">
                        <div v-html="scope.row.pfbz"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :disabled="scope.$index === 1" :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">2、财务风险</div>
            <el-table :data="riskTableData" :span-method="riArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准"></el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">3、服务品质（由客户服务负责修订）</div>
            <el-table :data="serviceTableData" :span-method="svArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明">
                    <template slot-scope="scope">
                        <div v-html="scope.row.wdsm"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div v-html="scope.row.pfbz"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">4、加分项目</div>
            <el-table :data="plusTableData" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="wdsm" label="维度说明">
                    <template slot-scope="scope">
                        <div v-html="scope.row.wdsm"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div v-html="scope.row.pfbz"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：以上资质条件、运营能力、服务品质均为必要条件，任何一方面不达要求均不得引入为合格供应商（①资质条件任一项不达标不得引入；②运营能力、服务品质各项总得分低于该项总分80%不得引入），战合供方参照第5条执行。</div>
            <div class="require-rule margin-bottom-20">2、评审流程：第一步、资料评审：收集资质材料或调研信息，审核通过后进入下一步评审 ；第二步、现场评审：运营能力，服务品质现场评估。</div>
            <div class="require-rule margin-bottom-20">3、组织形式：供应商引入由运配经理/中心经理/主管/线长牵头，并对评审结果负责，如有争议由分公司运配经理指定。</div>
            <div class="require-rule margin-bottom-20">4、评审小组：a.资料评审由供应商引入人员收集供应商资质条件材料，交由分公司资源管理员（如无对应岗位，则由运配/中心经理进行评审）；b.现场评审：由运配/中心经理/线长（至少1人到场）、财务经理、品质管理员、安全管理员、资源管理员、或其他指定人员组成不少于3人联合评审小组，分别负责评审供应商资质条件、运营能力、服务品质等，评审完成后签字即对评审结果负责。</div>
            <div class="require-rule margin-bottom-20">5、战合供方/4.2米及以下城配法人供方：为支持公司战略业务和新商业模式的发展，对于战略合作供方新成立的物流公司作为物流供方身份引入时，其中资质条件序号1、3条不符合不得引入，且营业执照需物流运输及相关经营范围，同时在供方引入流程审批附件中需增加分公司经理和战略共建部门负责人邮件审批记录。4.2米及以下车辆运作的城配法人供方序号2不强制要求。</div>
            <div class="require-rule margin-bottom-20">6、网点供方：为支持2C直配模式开展，对于网点供方作为供方身份引入时，仅需提供资质条件序号1（营业执照、法人身份证），且营业执照需物流运输及相关经营范围，其他资质不强制要求。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-配送【法人】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import BaseInfo from './BaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-配送【法人】
const TYPE = '37'

const INIT_QT = [
    { businessType: '配送', propertyNature: '法人', zzlx: '营业执照、法人身份证', qualificationFlag: '', sm: '此项中任何一条不达标不得引入(战合供方、2C网点供方、4.2米及以下城配法人供方，见评审要求)', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '道路运输经营许可证', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '提供可抵扣的运输增值税专用发票(必须是一般纳税人,税率9%）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '成立年限必须在1年以上', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '车队供应商需自有车辆不少于3台（车辆行驶证所有人与公司营业执照一致/资产证明）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无偷税漏税行为（电子税务局查询无欠税证明）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无扣货、客户重大投诉、贿赂员工等不良历史记录', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '提供集团亲属关系盖章表', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '同行业经验（20）', wdsm: '', pfbz: '1、行业服务经验：近3年服务过类似行业10分；近2年服务过类似行业8分；近1年服务过类似行业5分；无类似行业服务经验0分；<br/>2、配送场景服务经验：3年以上10分；2～3年为8分；1～2年为5分；不足1年为0分；2C网点供应有配送经验即得10分。', zf: '20', df: '', resultFlag: '', customerList: [{}, {}, {}] },
    { pgwd: '车辆资源（25分）', wdsm: '', pfbz: '车辆满足率得分条件：120%以上得15分；<br />110-120%(含)得12分；<br />100%-110%(含)得10分；<br />80%-100%(含)得6分；<br />0-80%不得分。<br/>2C网点供方车辆满足率100%及以上即得15分。', zf: '15', df: '', resultFlag: '', vehicleList: [{}] },
    { pgwd: '', wdsm: '自有车数量：<br />自有车辆1-5辆，6-9辆，10辆以上分阶梯打分', pfbz: '无自有车0分；自有车1-5辆2分；自有车6-9辆得3分；自有车10辆及以上5分；2C网点供方有自有车即得5分。', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '车型与需求匹配度<br />匹配度比例=符合业务需求的自有车辆/根据业务所需的车型数量*100%<br />（符合业务需求定义：客户要求使用飞翼车、侧帘车、厢式车、平板车、高栏车等，按照客户需求提供）', pfbz: '得分=匹配度比例*5', zf: '5', df: '', resultFlag: '' },
    { pgwd: '网络办公', wdsm: '网络及办公点布局<br />是否在当地设立分支机构（分公司、运作点等）', pfbz: '有1个得5分，无得0分', zf: '5', df: '', resultFlag: '' },
]

const INIT_RT = [
    { pgwd: '资金周转能力', wdsm: '应付账期：供应商可接受我司的付款周期', pfbz: '票后一个月5分；票后半月结为3分；票后周结为1分；每单结为0分。', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '押金：可接受抵押风险及运作保证金5万以上、2-5万、2万以下、及有效固定资产抵押情况', pfbz: '5万以上为5分、5万～2万为3分、2万以下为2分、有效固定资产抵押5分', zf: '10', df: '', resultFlag: '' },
]

const INIT_ST = [
    { pgwd: '团队运作经验', wdsm: '对接人员名单：<br />具有负责该业务的项目负责人、调度、现场、跟单对账对接人(部分可兼岗，且岗位配置1人不超3岗)', pfbz: '提供完整名单8分，不符合标准4分，未提供0分', zf: '8', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '常规配送车组（车+司机）<br />具备5个常规配送车组(司机+车辆+队长/调度或管理人员)', pfbz: '提供5组完整配送车组明细7分，不足5组3分，未提供0分', zf: '7', df: '', resultFlag: '' },
    { pgwd: '服务保障能力', wdsm: '应急处理：<br />旺季配送量暴涨等特殊时期是否有异常处理预案', pfbz: '无异常处理预案0分；<br />有异常处理预案3分；<br />有异常处理预案且有异常对接人5分。', zf: '5', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '商业险购买：<br />为对应车辆、货物、或随车人员购买商业险', pfbz: '查看投保记录，最近半年有记录得5分，无记录0分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '服务质量', wdsm: '诚信服务：<br />有该行业客户KPI盖章公函(或历史邮件通报)且达标或有该行业客户盖章表扬信或荣誉资质奖章，且服务期间无私自使用及占有或处理客户产品，1年内有无扣货记录，严重拖欠司机运费导致不良影响的事件', pfbz: '可提供客户KPI邮件或表扬信或奖牌等得5分；<br />无提供的得0分；<br />如发现存在违反品质禁令事项记录得0分。', zf: '5', df: '', resultFlag: '' },
    { pgwd: '管理体系', wdsm: '管理文件：<br />是否有品质、安全、订单管理、现场管理、回单管理、配送司机服务意识相关管理文件及培训记录', pfbz: '仅有相关管理文件2分；有相关管理文件并且有培训记录为3分；无标准无培训0分', zf: '3', df: '', resultFlag: '' },
    { pgwd: '', wdsm: '考核应用：<br />针对管理承运商或者配送司机，内部人员是否有按管理制度要求，输出相应的考评', pfbz: '有管理制度或管理要求2分，无0分', zf: '4', df: '', resultFlag: '' },
]

const INIT_PT = [
    { pgwd: '服务增值', wdsm: '路权和车况：<br />1、车辆年限（2分）；<br />2、是否有新能源车辆（电动或混合动力或清洁能源车辆）（2分）；<br />3、是否有禁行区域的具备通行证的备案车辆（6分）。', pfbz: '1、自有车车辆年限：4.2米（含）以下车龄5年以内；4.2米以上车龄8年以内；按车符合得1分，封顶2分；<br />2、有自有新能源车辆（电动或混合动力或清洁能源车辆）按照1辆车/分，封顶得2分；<br />3、有禁行区域的具备通行证的备案车辆按照1辆车/2分，封顶得6分。', zf: '10', df: '', resultFlag: '/' },
]

export default {
    components: { BaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            // SRM_YES,
            // currentId: null,
            // currentVersion: null,
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,

            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
            customerListCols: ['customerName', 'scale', 'serviceType', 'operationTime', 'deliveryScenario'],
            vehicleListCols: ['cargoMax', 'carNumberMax', 'availableSelfCar', 'availableCooperationCar', 'totalCar', 'carRite'],
            riskTableData: JSON.parse(JSON.stringify(INIT_RT)),
            serviceTableData: JSON.parse(JSON.stringify(INIT_ST)),
            plusTableData: JSON.parse(JSON.stringify(INIT_PT)),
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
            this.riskTableData = JSON.parse(JSON.stringify(INIT_RT))
            this.serviceTableData = JSON.parse(JSON.stringify(INIT_ST))
            this.plusTableData = JSON.parse(JSON.stringify(INIT_PT))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].resultFlag = data.operationalCapability.resultFlag
            this.operationTableData[0].customerList = data.operationalCapability.experience.customerList
            this.operationTableData[0].df = data.operationalCapability.experience.experienceScore
            this.vehicleListCols.forEach(key => {
                this.$set(this.operationTableData[1].vehicleList[0], key, data.operationalCapability.carResource.availableVehicles[key])
            })
            console.log(this.operationTableData[1])
            this.operationTableData[1].df = data.operationalCapability.carResource.availableVehicles.availableVehiclesScore
            this.operationTableData[2].df = data.operationalCapability.carResource.selfCarScore
            this.operationTableData[3].df = data.operationalCapability.carResource.matchScore
            this.operationTableData[4].df = data.operationalCapability.telecommutingScore
            this.riskTableData[0].resultFlag = data.financialRisk.resultFlag
            this.riskTableData.forEach((item, index) => {
                item.df = data.financialRisk['risk' + (index + 1) + 'Score']
            })
            this.serviceTableData[0].resultFlag = data.serviceQuality.resultFlag
            this.serviceTableData.forEach((item, index) => {
                item.df = data.serviceQuality['quality' + (index + 1) + 'Score']
            })
            this.plusTableData[0].df = data.addScoreItem.addScoreItem1Score
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const clValid = this.customerListValidate()
            const vlValid = this.vehicleListValidate()
            const scoreValid = this.scoreValidate()
            if (supplierInfo && qlfValid && clValid && vlValid && scoreValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，字长不能超过20位(通讯地址100位)，可调配车辆表格、得分列请输入数字，可保留两位小数!',
                    duration: 4000,
                })
            }
        },
        // 运营能力-同行业经验-维度说明的表格校验
        customerListValidate() {
            let valid = true
            const { customerList } = this.operationTableData[0]
            // 判断所有行都无数据
            const allIsEmpty = customerList.every(item => !item.customerName)
            if (allIsEmpty) {
                valid = false
                return valid
            }
            // 过滤出有数据的行，并校验格式
            customerList.filter(item => this.customerListCols.some(key => !!item[key])).forEach(item => {
                this.customerListCols.forEach(key => {
                    if (['', null, undefined].includes(item[key]) || item[key].length > 20) {
                        valid = false
                    }
                    if (key === 'scale' && !/^\d+(\.\d{1,2})?$/.test(item.scale)) {
                        valid = false
                    }
                })
            })
            return valid
        },
        vehicleListValidate() {
            return this.vehicleListCols.slice(0, 4).every(key => {
                return !this.veInputError(this.operationTableData[1].vehicleList[0][key], key)
            })
        },
        // 所有得分项格式校验
        scoreValidate() {
            const oError = this.operationTableData.some(item => this.scoreError(item.df, item.zf))
            const rError = this.riskTableData.some(item => this.scoreError(item.df, item.zf))
            const sError = this.serviceTableData.some(item => this.scoreError(item.df, item.zf))
            const pError = this.plusTableData.some(item => this.scoreError(item.df, item.zf))
            return !oError && !rError && !sError && !pError
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const availableVehicles = {
                availableVehiclesScore: this.operationTableData[1].df,
            }
            this.vehicleListCols.forEach(key => {
                availableVehicles[key] = this.operationTableData[1].vehicleList[0][key]
            })
            // availableVehicles.availableVehiclesScore = this.operationTableData[1].df
            const operationalCapability = {
                resultFlag: this.operationTableData[0].resultFlag,
                experience: {
                    experienceScore: this.operationTableData[0].df,
                    customerList: this.operationTableData[0].customerList,
                },
                carResource: {
                    availableVehicles,
                    selfCarScore: this.operationTableData[2].df,
                    matchScore: this.operationTableData[3].df,
                },
                telecommutingScore: this.operationTableData[4].df,
            }
            const financialRisk = {
                resultFlag: this.riskTableData[0].resultFlag,
            }
            this.riskTableData.forEach((item, index) => {
                financialRisk['risk' + (index + 1) + 'Score'] = item.df
            })
            const serviceQuality = {
                resultFlag: this.serviceTableData[0].resultFlag,
            }
            this.serviceTableData.forEach((item, index) => {
                serviceQuality['quality' + (index + 1) + 'Score'] = item.df
            })
            const addScoreItem = {
                addScoreItem1Score: this.plusTableData[0].df
            }
            params.onlineContent = JSON.stringify({ supplierInfo, supplierQualification, operationalCapability, financialRisk, serviceQuality, addScoreItem })
            return params
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [8, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 1) {
                    return [3, 1];
                } else if ([2, 3].includes(rowIndex)) {
                    return [0, 0];
                }
            } else if (columnIndex === 5) {
                if (rowIndex === 0) {
                    return [5, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        riArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [2, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        svArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if ([0, 2, 5].includes(rowIndex)) {
                    return [2, 1];
                } else if ([1, 3, 6].includes(rowIndex)) {
                    return [0, 0];
                }
            } else if (columnIndex === 5) {
                if (rowIndex === 0) {
                    return [7, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        cuInputError(val, prop, row, index) {
            let isError = false
            const allIsEmpty = this.customerListCols.every(key => ['', null, undefined].includes(row[key]))
            if (allIsEmpty) {
                isError = false
            } else if (prop === 'scale') {
                isError = !/^\d+(\.\d{1,2})?$/.test(val)
            } else {
                isError = ['', null, undefined].includes(val) || val.length > 20
            }
            return isError
        },
        veInputError(val, prop, row, index) {
            let isError = false
            if (prop === 'cargoMax') {
                isError = !/^\d+(\.\d{1,2})?$/.test(val)
            } else {
                isError = !/^\d+$/.test(val)
            }
            return isError
        },
        isError(val) {
            return ['', null, undefined].includes(val)
        },
        scoreError(score, max) {
            // 不是可保留两位小数的数字格式 || 大于最大值
            return !/^\d+(\.\d{1,2})?$/.test(score) || Number(score) > Number(max)
        },
        getDf(percentVal) {
            let score = 0
            if (percentVal) {
                const value = Number(percentVal.replace('%', ''))
                if (value >= 120) {
                    score = 15
                } else if (value >= 110) {
                    score = 12
                } else if (value >= 100) {
                    score = 10
                } else if (value >= 80) {
                    score = 6
                }
            }
            return score
        }
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
        operationTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const { carNumberMax, availableSelfCar, availableCooperationCar } = val[1].vehicleList[0]
                let totalCar = !this.veInputError(availableSelfCar, 'availableSelfCar') && !this.veInputError(availableCooperationCar, 'availableCooperationCar') ?
                    Number(availableSelfCar) + Number(availableCooperationCar) : ''
                val[1].vehicleList[0].totalCar = totalCar
                val[1].vehicleList[0].carRite = !this.veInputError(carNumberMax, 'carNumberMax') && Number(totalCar) >= 0 ?
                    (Number(carNumberMax) === 0 ? '120%' : (Number(totalCar) / Number(carNumberMax) * 100).toFixed(2) + '%') : ''
                val[1].df = this.getDf(val[1].vehicleList[0].carRite)
                val[0].resultFlag = val.some(item => Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber()) ? '不通过' : '通过'
            },
            deep: true,
        },
        riskTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber()) ? '不通过' : '通过'
            },
            deep: true,
        },
        serviceTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => Number(item.df) > Number(item.zf) || Number(item.df) < Decimal.mul(item.zf, 0.8).toNumber()) ? '不通过' : '通过'
            },
            deep: true,
        },
    },
}
</script>
<style lang="less">
.key-data-delivery-legal-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>